export default {
    name: "popup",
    props:['isShow'],
    data(){
      return {
        certTypeName:'',
        idNumber:'',
        realName:'',
        userID:'',
        headerPic:'',
        nickName:'',
      }
    },
    methods:{
      backEvent(){
        if(this.isShow){
          this.$emit('update:isShow', false)
        } else {
         this.appMethod.goback(this)
        }
      }
    },
    mounted (){
      this.userID = Cookie.get('customerCode');
      if(Cookie.get('userSeq')){
        this.api.queryCustomerInfo(Cookie.get('userSeq'))
          .then((res) =>{
            this.certTypeName = res.data.certTypeName;
            this.idNumber = res.data.idNumber;
            this.realName = res.data.realName;
            this.headerPic = res.data.headerPic;
            this.nickName = res.data.nickName;
          });
      }
    }
}



// WEBPACK FOOTER //
// ./src/components/text/mixin/popup.js